var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLastSeen = function SvgLastSeen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M20.936 13.433a8.999 8.999 0 1 1-10.37-10.37M20.5 8.798a8.92 8.92 0 0 1 .437 1.634M19.005 6.195a8.948 8.948 0 0 0-1.2-1.2M15.203 3.502a8.903 8.903 0 0 0-1.635-.439"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.002 12.391h-4.393V6.998"
  })));
};
export { SvgLastSeen as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZjdmOTQwNWI5OTYzMmE5ZjBhNjA1MDg0NWEwYjcxZjUuc3ZnIjs=";